import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Radio } from 'antd';
// Local Deps
import NFButton from '../../../../components/primitives/NFButton';
import msgs from '../../../../config/messages';

// import Loading from '../../components/Loading';
export default class CollectCage extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    currentFlow: PropTypes.string.isRequired,
    setRegistatrationFlow: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  render() {
    const {
      setRegistatrationFlow,
      onSubmit,
      onCancel,
      currentFlow,
    } = this.props;
    const radioStyle = {

      'font-size': '16px',
    };
    return (
      <div>
        <Row style={{ flexWrap: 'nowrap' }}>
          <Col style={{ marginTop: '16px' }}>
            {/* <!-- LOADING --> */}
            {/* <!-- CONTENT --> */}
            <div className="nf-registration__content">
              <Row className="nf-row--justify-end" />
              {/* <!-- USERS GRID --> */}
              <div className="nf-registration__layout">
                <Radio.Group
                  onChange={setRegistatrationFlow}
                  value={currentFlow}
                >
                  <div className="registration-radio-wrapper">
                    <Radio style={radioStyle} value="new">
                      Organization
                    </Radio>
                    <p className="nf-radio-text">
                      I am registering a new organization or business and will
                      serve as my organization&#39;s administrator on the ICON
                      Portal.
                    </p>
                  </div>
                  <div className="registration-radio-wrapper">
                    <Radio style={radioStyle} value="industry">
                      Industry User
                    </Radio>
                    <p className="nf-radio-text">
                      I am registering as a new user for a non-government
                      organization or business that is already registered on the
                      ICON Portal.
                    </p>
                  </div>
                  <div className="registration-radio-wrapper">
                    <Radio style={radioStyle} value="gov">
                      Government Employee or Government Contractor
                    </Radio>
                    <p className="nf-radio-text">
                      I am registering as a direct employee of a U.S. government agency or
                      organization, or as a contractor working in support of a U.S.
                      government agency or organization.
                    </p>
                  </div>
                  {/* <div className="registration-radio-wrapper">
                    <Radio style={radioStyle} value="gov-without-procurement">
                      Government Employee or Government Contractor Without
                      RFQ Capabilities
                    </Radio>
                    <p className="nf-radio-text">I am a Government Employee/Contractor who DOES NOT have RFQ Capabilities for my Agency. I will be using ICON for research on Industry Tooling and Supplier Capabilities only.</p>
                  </div>
                  <div className="registration-radio-wrapper">
                    <Radio style={radioStyle} value="gov-with-procurement">
                      Government Employee or Government Contractor With
                      RFQ Capabilities
                    </Radio>
                    <p className="nf-radio-text">I am a Government Employee/contractor who HAS RFQ Capabilities for my Agency. I want to be able to interact directly with ICON Industry partners in order to facilitate procurement actions.</p>
                  </div> */}
                </Radio.Group>
                <div className="nf-registration--wrapper">
                  <div className="nf-registration__buttons">
                    <NFButton
                      className="nf-button--gray-border"
                      style={{ marginRight: '16px' }}
                      onClick={() => {
                        onCancel(true);
                      }}
                    >
                      {msgs.Form.cancelButton}
                    </NFButton>
                    <NFButton
                      disabled={!currentFlow}
                      className="nf-button--form nf-button--orange"
                      type="submit"
                      onClick={() => {
                        onSubmit();
                      }}
                    >
                      {msgs.Form.continueButton}
                    </NFButton>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/InitialRequest/InitialRequest.jsx